'use client';

import clsx from 'clsx';
import Link from 'next/link';

import { SearchArticlesInput } from '@/components/SearchArticlesInput';
import HorizontalLogo from '@/shared/assets/logo_horizontal.svg?svg';
import LogoIcon from '@/shared/assets/logo.svg?svg';
import SearchIcon from '@/shared/assets/search.svg?svg';
import { Button } from '@/shared/ui';
import { Navigation } from './Navigation';
import styles from './Header.module.css';

export const Header = ({
  toggleMenu,
  isMenuOpen,
}: {
  toggleMenu: () => void;
  isMenuOpen: boolean;
}) => {
  return (
    <div className={styles.header} data-state={isMenuOpen ? 'open' : 'closed'}>
      <div className={styles.top}>
        <Link className={styles.logo} href="/">
          <LogoIcon className={styles.logo_desktop} />
          <HorizontalLogo className={styles.logo_mobile} />
        </Link>

        <div className={styles.search}>
          <SearchArticlesInput />
        </div>

        <div className={styles.searchMobile}>
          <SearchIcon />
        </div>

        <Button
          className={clsx(styles.mobileMenuButton, 'scroll')}
          onClick={toggleMenu}
          variant="icon"
          data-active={isMenuOpen}
        />
      </div>
      <div className={styles.bottom}>
        <Navigation />
      </div>
    </div>
  );
};
